
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import CarInfo from "@/modules/Car/components/tabs/CarInfo.vue";
  import CarTableArchive from "@/modules/Car/components/tabs/CarTableArchive.vue";
  import CarTableCameras from "@/modules/Car/components/tabs/CarTableCameras.vue";
  import {bus} from "@/plugins/bus";
  import CarTableMovements from "@/modules/Car/components/tabs/CarTableMovements.vue";
  import {copyToClipboard} from "@/plugins/clipboard";
  import CarNumber from "@/components/CarNumber.vue";
  import CarAntiTheft from "@/modules/CarList/components/AntiTheftComponents/CarAntiTheft.vue";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
  import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      AppDialog,
      CarInfo,
      CarTableCameras,
      CarTableArchive,
      CarTableMovements,
      CarNumber,
      CarAntiTheft,
    },
  })
  export default class CarPopup extends Vue {
    $refs: any;
    tabPosition = 'top';
    activeTab = ICar.CarPopupTab.Info;
    tabName = ICar.CarPopupTab;
    tabs = ICar.CarPopupTabs;
    isDataReady = false;
    animateDisplay = false;
    accessToCard = false;

    get storeState(): IAppState { return this.$store.state; }
    get displayPopup() { return this.storeState.car.displayPopup; }
    get displayContent() { return this.storeState.car.displayContent; }
    get activeCar(): ICar.IEntity { return this.storeState.car.activeCar; }
    get createMode() { return (this.activeCar && !this.activeCar.carId) || !this.activeCar; }
    get popupPayload(): ICarStore.IPopupPayload { return this.storeState.car.popupPayload; }
    get easyModeInterface() { return !this.storeState.auth.userAccess.extModeFlag; }

    get hasInArchive() { return this.activeCar && this.activeCar.carStatusId === ICar.CarStatusId.Archive; }

    async mounted() {
      bus.$on(ICarStore.Events.ReloadCarPopupData, async () => {
        this.isDataReady = false;
        await this.$nextTick();
        await this.initPopupData();
      });
      await this.initPopupData();
    }

    async initPopupData() {
      await this.$store.dispatch('car/getCar');
      this.accessToCard = this.activeCar ? Boolean(this.activeCar.scOpenCarCard) : true;
      this.isDataReady = true;

      this.animateDisplay = true;

      if (this.popupPayload.tabForOpen) {
        setTimeout(() => {
          this.activeTab = this.popupPayload.tabForOpen;
          this.toggleTab(this.popupPayload.tabForOpen);
        }, 0);
      }
    }

    toggleTab(tab) {
      const tabActions = {
        [ICarPopupTables.CarPopupTab.Movements]: { ref: 'tableMovements', action: 'prepareData', hasAccess: true, },
        [ICarPopupTables.CarPopupTab.Archive]: { ref: 'tableArchive', action: 'prepareData', hasAccess: this.accessToCard, },
        [ICarPopupTables.CarPopupTab.Camera]: { ref: 'tableCameras', action: 'prepareData', hasAccess: true, },
        [ICarPopupTables.CarPopupTab.AntiTheft]: { ref: 'carAntiTheft', action: 'prepareData', hasAccess: this.accessToCard, },
      };
      let activeTab = tabActions[this.activeTab];
      if (activeTab && activeTab.hasAccess) this.$refs[activeTab.ref][activeTab.action]();
      else if (activeTab && !activeTab.hasAccess) this.activeTab = ICarPopupTables.CarPopupTab.Info;
    }

    async onClose() {
      await this.$store.dispatch('car/closeCarPopup');
    }

    copyNumber(createMode = false) {
      if (createMode && !this.popupPayload.carNumber) return;

      let carNumber = createMode ? this.popupPayload.carNumber : this.activeCar.carNumber;

      copyToClipboard(carNumber);
      this.$notify({
        title: 'Успешно',
        message: 'Номер скопирован',
        type: 'success'
      });
    }

    destroyed() {
      bus.$off(ICarStore.Events.ReloadCarPopupData);
    }
  }
